import t from 'tcomb';
import {getDefaultDemographicInfo, DemographicInfo} from './DemographicInfo';
import {Users} from "./Users";

const State = t.struct({
    demographicInformation: DemographicInfo,
    users: t.maybe(t.list(Users)),
    isResearcher: t.Boolean
}, 'State');

export function getDefaultState() {
    return State({
        demographicInformation: getDefaultDemographicInfo(),
        users: null,
        isResearcher: false
    })
}